import Rollbar from 'rollbar';

import config from './config';

const rollbarConfig = {
  accessToken: config.rollbarAccessToken,
  environment: config.environment,
  enabled: config.environment !== 'development',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
};

const rollbar = new Rollbar(rollbarConfig);

export const rollbarConfigObject = rollbarConfig;
export default rollbar;
